import { Modal } from 'ctls/modal/Modal';
import { SrchDropDown } from 'header/header/srchinput/SrchDropDown';
import { useHandleSrch } from 'header/header/srchinput/useHandleSrch';
import useOutsideClick from 'hooks/useOutsideClick';
import { SsqImages } from 'images/SsqImages';
import { tc } from 'language/i18nkey';
import icon_left_arrow from 'mainpage/toparea/srchinput/icon_left_arrow.svg';
import { InputAssistFill } from 'mainpage/toparea/srchinput/InputAssistFill';
import { useRcentSearch } from 'mainpage/toparea/srchinput/useRcentSearch';
import { useZstdSrch } from 'mainpage/toparea/srchinput/useZstdSrch';
import queryString from 'query-string';
import { useEffect, useRef } from 'react';
import { fontFamilyBold, fontFamilyRegular } from 'style/fonts';
import styled from 'styled-components';

type Props = {};
export const MobileSrchInput = (props: Props) => {
  // Assist는 inputTmp를 참조하는데, 이를 동기화해 줄 헤더 검색창이 모바일엔 없어 여기서 직접 맞춘다.
  const { input, setInput, setInputTmp, showMobileSrch, setShowMobileSrch } = useZstdSrch();
  const [, addRecent] = useRcentSearch();
  const { handleSrch: newSearch } = useHandleSrch();
  useEffect(() => {
    const qs = queryString.parse(location.search);
    if (qs.searchInput) {
      if (typeof qs.searchInput === 'string') {
        setInput(qs.searchInput);
        setInputTmp(qs.searchInput);
      } else {
        console.error('error type of qs.searchInput is not string', typeof qs.searchInput);
      }
    }
  }, []);
  const handleSearch = (e) => {
    if (input?.trim()) {
      addRecent(input);
      newSearch(input);
      setShowMobileSrch(false);
    } else {
      console.error('E empty', input);
    }
  };

  const handleFocus = () => {};

  const refAssist = useRef<HTMLDivElement>(null);
  const refInput = useRef<HTMLInputElement>(null);

  useOutsideClick([refAssist, refInput], () => {}, []);

  useEffect(() => {
    if (showMobileSrch) {
      document.body.classList.add('modal-open');
      setInputTmp(input);
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [showMobileSrch]);

  if (!showMobileSrch) return null;
  return (
    <Modal onClick={() => setShowMobileSrch(false)}>
      {/* 마커: 모바일 검색창이 열린 동안 우하단 AI 챗봇 런처를 모달 뒤로 보내기 위한 식별 클래스 (GlobalStyle 참고) */}
      <ModalBody className='ssq-mobile-srch-overlay' onClick={(e) => e.stopPropagation()}>
        <TopBar>
          <BackBtn onClick={() => setShowMobileSrch(false)}>
            <img src={icon_left_arrow} />
          </BackBtn>
          <Body>
            <Input
              placeholder={tc('i18n_srch_input_placeholder')}
              value={input || ''}
              ref={refInput}
              onFocus={handleFocus}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch(e)}
              onChange={(e) => {
                setInput(e.target.value);
                setInputTmp(e.target.value);
              }}
            />
            <SrchDropDown className='' novbar={true} mobile={true} />
            <SrchIcon src={SsqImages.header.icon.search()} onClick={handleSearch} />
          </Body>
        </TopBar>
        <InputAssistFill refAssist={refAssist} />
      </ModalBody>
    </Modal>
  );
};

const BackBtn = styled.button`
  display: flex;
  align-items: center;
  padding: 0 0 0 1.7rem;
`;

const SrchIcon = styled.img`
  display: inline-block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin: auto 2.8rem auto 0.4rem;
  cursor: pointer;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #407dd9;
  margin-top: 2rem;
`;

const ModalBody = styled.div`
  width: 100%;
  max-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

const Body = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  min-width: 0;
  align-items: center;
  height: fit-content;
  border-radius: 10rem;
  background-color: white;
`;

const Input = styled.input`
  flex: 1;
  min-width: 0;
  ${fontFamilyBold};
  font-size: 2rem;
  line-height: 2.4rem;
  padding: 2rem 1.4rem 2rem 0.8rem;

  &:placeholder-shown {
    font-size: 1.2rem;
  }
  
  &::placeholder {
    ${fontFamilyRegular};
    font-size: 1.2rem;
  }
`;
